/* eslint-disable indent,quote-props,no-unused-vars,dot-notation,padded-blocks,no-,no-restricted-syntax */
/**
 * Details Controller file
 * @class
 */
import vasActivationModalTemplate from '../SavedWithSuccessModal.html';
import suggestToMakeMenuTemplate from '../SuggestToMakeMenuModal.html';
import suggestToInsertAddressTemplate from '../SuggestToInsertAddressModal.html';

class officeDeliveryController {



  /* @ngInject */

  constructor($log, $q, $scope, $timeout, MerchantConfigurationService,
              MerchantVasService, StorageService, $rootScope, ModalFactory,
              TermsService, NewTokenService, CatalogService) {


    const that = this;
    that.currentVasTypeId = MerchantVasService.getVasesTypes()['OFFICE-DELIVERY'];
    that.currentWalletId = NewTokenService.getMerchantWalletID();
    that.isSuperAdmin = StorageService.getLocalStorage('superAdmin');
    that.vasMenus = {};

    this.showVasConfigurationMenuError = () => {
      const closeModal = () => {
        modal.deactivate();
        $timeout(modal.destroy, 1000);
      };

      const modal = new ModalFactory({
        overlay: true,
        overlayClose: true,
        template: suggestToMakeMenuTemplate,
        class: 'default',
        contentScope: {
          okFunc: closeModal
        }
      });

      modal.activate();
    };

    this.showVasConfigurationAddressError = () => {
      const closeModal = () => {
        modal.deactivate();
        $timeout(modal.destroy, 1000);
      };

      const modal = new ModalFactory({
        overlay: true,
        overlayClose: true,
        template: suggestToInsertAddressTemplate,
        class: 'default',
        contentScope: {
          okFunc: closeModal
        }
      });

      modal.activate();
    };

    this.showVasConfigurationSuccess = () => {
      const closeModal = () => {
        modal.deactivate();
        $timeout(modal.destroy, 1000);
      };

      const modal = new ModalFactory({
        overlay: true,
        overlayClose: true,
        template: vasActivationModalTemplate,
        class: 'default',
        contentScope: {
          okFunc: closeModal
        }
      });

      modal.activate();
    };

    that.save = () => {
      // var preparedTime = new Date(that.currentVas.configuration.prepareTime).getMinutes()
      var preparedTime = 15;
      that.currentVas.configuration.openingHours = that.getDaysWithPrepareTime(preparedTime);

      if (that.currentVas.configuration.deliveryCost) {
        that.currentVas.configuration.deliveryCost = toCents(that.currentVas.configuration.deliveryCost);
      }
      if (that.currentVas.configuration.deliveryThreshold) {
        that.currentVas.configuration.deliveryThreshold = toCents(that.currentVas.configuration.deliveryThreshold);
      }

      var shippingAddress = that.currentVas.configuration.shippingAddress;
      if (shippingAddress) {
          shippingAddress.country = 'I';
          shippingAddress.type = 'SHIPPING';
          shippingAddress.postalCode = shippingAddress.zip || shippingAddress.postalCode;
          shippingAddress.streetNumber = shippingAddress.nr || shippingAddress.streetNumber;
          shippingAddress.preferred = 0;
      } else {
        if (that.currentVas.configuration.enabled) {
          console.log('err');
          that.showVasConfigurationAddressError();
          return;
        }
      }

      MerchantVasService.configureVas(that.currentVas.configuration, that.currentVas.id)
        .then(
          (ok) => {
            that.currentVas.configuration = ok.data;
            that.currentVas.configuration.deliveryCost /= 100;
            that.currentVas.configuration.deliveryThreshold /= 100;

            that.showVasConfigurationSuccess();
          }
        );

    };

    that.fillMenus = () => {

      CatalogService.getMenus().then((data) => {

        that.vasMenus = data;
        if (!that.vasMenus || that.vasMenus.length === 0) that.showVasConfigurationMenuError();

      });

    };

    $scope.disableButton = () => {
      if (that.getDaysWithPrepareTime().some(function (el) { return el.error; }))
        return true;
      else
        return false;
    };

    const toCents = (amount) => {
      const a = '' + amount; // Making sure is a string
      return parseInt((a.replace(',', '.') * 100).toPrecision(12));
    };

    const init = () => {
      that.fillMenus();
      var merchantProfile = JSON.parse(StorageService.getLocalStorage('userContext'));
      MerchantVasService.getVasByType(that.currentVasTypeId, merchantProfile.business.id)
        .then(
          (response) => {
            that.currentVas = response.data;
            that.currentVas.configuration.deliveryCost /= 100;
            that.currentVas.configuration.deliveryThreshold /= 100;

            var shippingAddress = that.currentVas.configuration.shippingAddress;
            that.fullAddress = shippingAddress ? (shippingAddress.street + ' ' + shippingAddress.streetNumber + ', ' + shippingAddress.city + ', ' + shippingAddress.province + ' ' + shippingAddress.postalCode) : '';
            that.setDays(that.currentVas.configuration.openingHours);
          },
          (error) => {
            alert('error retrieving the vas!');
          }
        );
    };

    that.$onInit = init;



  }

}

export default officeDeliveryController;



/** WEBPACK FOOTER **
 ** ./client/app/components/services/officeDelivery/officeDelivery.controller.js
 **/